import React, { Component } from 'react';
import Image from 'next/image';
import { Modal, Row, Col } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import { timerFormat } from '../../utils/utils';

import defaultImg from '../../public/images/hidream-admin-bg.jpg';

export class VideoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentVideoSrc: {},
      delModelVisible: [],
    };
  }

  showModal = (item) => {
    const delModelVisible = this.state.delModelVisible;
    delModelVisible[item.title] = true;

    this.setState({
      currentVideoSrc: item.videoSrc,
      delModelVisible,
    });
  };

  handleCancel = () => {
    this.setState({
      delModelVisible: [],
    });
  };

  render() {
    const { delModelVisible, currentVideoSrc } = this.state;
    const { videoData } = this.props;

    videoData.forEach((item) => {
      item.videoSrc = {
        poster: item.src
          ? `https://cdn-storage.hidream.net/${item.src}`
          : defaultImg,
        src: item.video_url,
      };
    });

    return (
      <ul className="videolist row">
        {videoData.map((item, index) => {
          return (
            <li className="videoItem col" key={`video-${index}`}>
              <div
                className="video"
                onClick={() => {
                  this.showModal(item);
                }}
              >
                <Image
                  src={
                    item.src
                      ? `https://cdn-storage.hidream.net/${item.src}`
                      : defaultImg
                  }
                  alt={item.title}
                  width={444}
                  height={250}
                  layout="responsive"
                />
                <span className="play">
                  <CaretRightOutlined />
                </span>
              </div>

              <div className="videoContent">
                <div
                  className="header"
                  onClick={() => {
                    this.showModal(item);
                  }}
                >
                  <div className="title">{item.title}</div>
                  <p className="description">
                    {item.description ? item.description : ''}
                  </p>
                </div>

                <Row>
                  <Col span={12} className="origin">
                    <Image
                      src={require('../../public/images/hi.png').default}
                      alt="hidream"
                    />
                    讯梦国际
                  </Col>
                  <Col span={12} className="time">
                    {item.updated_at
                      ? timerFormat(item.updated_at)
                      : item.updated_at}
                  </Col>
                </Row>
              </div>

              {delModelVisible[item.title] ? (
                <Modal
                  title="视频播放"
                  visible={delModelVisible[item.title]}
                  onCancel={this.handleCancel}
                  destroyOnClose
                  maskClosable={true}
                  footer={null}
                  width={960}
                  centered
                  className="videoModal"
                >
                  <Player
                    playsInline
                    poster={currentVideoSrc.poster}
                    src={currentVideoSrc.src}
                    fluid={false}
                    width={960}
                    height={540}
                  >
                    <ControlBar
                      autoHide={false}
                      disableDefaultControls={false}
                    />
                    <BigPlayButton position="center" />
                  </Player>
                </Modal>
              ) : null}
            </li>
          );
        })}
      </ul>
    );
  }
}

export default VideoList;
